import React, { FunctionComponent } from 'react';
import * as graphCMS from '../../../domain/graphcms';
import { getAdvByTypeSync } from '../../../services/advs/advs';
import AdvFluid from '../adv-fluid/AdvFluid';

interface AdvFluidAdapterProps {
  advFluidType?: graphCMS.AdvFluidType,
  variant?: graphCMS.AdvFluidVariant,
  dataTrackingPrefix?: string,
}

const AdvFluidAdapter: FunctionComponent<AdvFluidAdapterProps> = ({
  advFluidType = graphCMS.AdvFluidType.SELL_PROPERTY,
  variant = graphCMS.AdvFluidVariant.VARIANT_1,
  dataTrackingPrefix,
}) => {
  const advData = getAdvByTypeSync(advFluidType);

  return (
    <AdvFluid
      {...advData}
      dataTracking={`${dataTrackingPrefix ? `${dataTrackingPrefix}:` : ''}AdvFluid:${advFluidType}:${variant}`}
      variant={variant}
    />
  );
};

export default AdvFluidAdapter;
